import { Application } from "@hotwired/stimulus"

const application = Application.start()
// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

console.log("Stimulus is loaded:", window.Stimulus)
window.Stimulus // OHNE das geht es nicht
export { application }
